import React from 'react';
import { DividerSection } from '../global/components/layout/divider-section';
import { MainContent } from '../global/components/layout/main-content-container';
import { PageContainer } from '../global/components/layout/page-container';
import { CpgUserTypes } from '../pages/account-info/features/personal-info/personal-info-models';

export interface DashboardUser {
    name: string,
    clientGuid : string,
    roleMatrix: string[],
    isClergy: boolean,
}

interface Props {
    setUserCallback: (user: DashboardUser) => void,
}

const sampleDashboardUsers : DashboardUser[] = [    
    {        
        name: 'Diocesan Administrator',
        clientGuid: '82e26758-42c2-4b14-b386-41233d4636c7',
        roleMatrix: ['DiocesanAdministrator'],
        isClergy: false,
    },
    {        
        name: 'Group Administrator',
        clientGuid: 'eb152431-db23-4e28-9c88-fdbf98070b2b',
        roleMatrix: ['SeniorGroupPlanAdmin'],
        isClergy: false,
    },    
    {        
        name: 'Institution Administrator',
        clientGuid: 'A4001AEC-3BAE-42A1-82DD-F0D687012C59',
        roleMatrix: ['SeniorOfficer'],
        isClergy: false,
    },
    {        
        name: 'Clergy',
        clientGuid: 'EBBDAC65-9CD9-4021-A1C3-7291369DE090',
        roleMatrix: [],
        isClergy: true,
    },
    {        
        name: 'Lay',
        clientGuid: 'A78AB8DB-ECD3-455D-935D-9F6847B29E3D',
        roleMatrix: [],
        isClergy: false,
    },
];

export function TcsmDashboardUsers(props: Props) {

    const [dashboardUser, setDashboardUser] = React.useState(null);    

    function setClergy(isClergy: boolean){
        document.cookie = `CPGUSERSTATUS=${ isClergy ? CpgUserTypes.ACTIVE_CLERGY : CpgUserTypes.ACTIVE_LAY}; path=/`;
    }

    function selectChanged(e){
        const selectedValue = e.target.value;

        if (dashboardUser?.clientGuid === selectedValue) return;
        
        const selectedUser = sampleDashboardUsers.find(du => du?.clientGuid === selectedValue);

        if (props?.setUserCallback){
            props.setUserCallback(selectedUser);
        }
        
        setClergy(selectedUser.isClergy);

        setDashboardUser(selectedUser);        
    }        

    return (
        <PageContainer>			
            <MainContent>				
                <DividerSection removeDivider sectionText='Personas'>
                    <select onChange={selectChanged}> 
                        <option value=""> -- Select a persona -- </option>
                        {sampleDashboardUsers.map((du) => <option selected={du?.clientGuid === dashboardUser?.clientGuid}  value={du.clientGuid}>{du.name}</option>)}
                    </select>
                </DividerSection>
            </MainContent>        
        </PageContainer>
    );
}